import { render, staticRenderFns } from "./TopNabarProfile.vue?vue&type=template&id=5409cde4&scoped=true&"
import script from "./TopNabarProfile.vue?vue&type=script&lang=js&"
export * from "./TopNabarProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5409cde4",
  null
  
)

export default component.exports